import React from "react";
import "./explanation-markdown-boundary.scss";

// Wraps a Markdown-rendered explanation. Pathological content (for example
// thousands of nested list markers) can make the Markdown parser overflow the
// stack while rendering; without a boundary that blanks the whole app. Show the
// explanation as plain text instead, and try Markdown again when it changes.
class ExplanationMarkdownBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { failed: false };
  }

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidUpdate(prevProps) {
    if (this.state.failed && prevProps.text !== this.props.text) {
      this.setState({ failed: false });
    }
  }

  render() {
    if (this.state.failed) {
      return <p className="explanation-plain-text">{this.props.text}</p>;
    }
    return this.props.children;
  }
}

export default ExplanationMarkdownBoundary;
